import {Signal} from 'typed-signals'

import {MediaQuery} from '@services/MediaQuery'
import {WindowService} from '@services/WindowService'

export class ProgressElement {
  element: HTMLDivElement | null = null
  stickyElement: HTMLDivElement  | null = null
  mq = MediaQuery.create()
  observer: IntersectionObserver | null = null
  initialTop = 0
  window = WindowService.create()
  onProgress = new Signal<(percent: number) => void>()

  constructor() {
    this.onIntersection = this.onIntersection.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)
  }

  onResize() {
    const {top = 0} = this.element?.getBoundingClientRect() || {}
    this.initialTop = top + window.scrollY
  }

  init(element: HTMLDivElement, stickyElement: HTMLDivElement) {
    this.element = element
    this.stickyElement = stickyElement

    this.window.onResize.connect(this.onResize)

    if (this.element) {
      this.observer = new IntersectionObserver(this.onIntersection, {
        rootMargin: '0px',
        threshold: [1, 0.9, 0.8, 0.7, 0.6, 0.5],
      })
      this.observer.observe(this.stickyElement)
    }

    this.onResize()
  }

  destroy() {
    this.disable()
    this.window.onResize.disconnect(this.onResize)
    this.observer?.disconnect()
  }

  getScrollMaxAmount() {
    const {height = 0} = this.element?.getBoundingClientRect() || {}
    return height - window.innerHeight
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (!entry.rootBounds) return
      const isDisabled = !entry.isIntersecting
      if (isDisabled) {
        this.disable()
      } else {
        this.enable()
      }
    }
  }

  onScroll() {
    const {top = 0} = this.stickyElement?.getBoundingClientRect() || {}
    const offsetTop = top + window.scrollY

    const deltaY = offsetTop - this.initialTop

    const max = this.getScrollMaxAmount()
    const per = deltaY / max
    this.onProgress.emit(per)
  }

  enable() {
    this.onResize()
    window.addEventListener('scroll', this.onScroll)
  }

  disable() {
    window.removeEventListener('scroll', this.onScroll)
  }

}
